import instanceConst from '@/consts/instance.const';
import userRoleConst from '@/consts/userRole.const';
import dashboardNavbarConst from '@/consts/dashboardNavbar.const.js';

export default [
  // Valuation (VUE)
  {
    label: 'components.home.NavigationBarComponent.ValuationVue.Title',
    instances: [],
    roles: `${userRoleConst.ADMIN}`,
    requiresAuth: true,
    children: [
      {
        label: 'pages.globalEndToEnd.dashboardNavbar.mandates',
        key: 'mandates',
        route: '/mandates',
        instances: [],
        roles: `${userRoleConst.ADMIN}`,
        requiresAuth: true,
        id: dashboardNavbarConst.MANDATES,
      },
      {
        label: 'pages.globalEndToEnd.dashboardNavbar.properties',
        key: 'properties',
        route: '/properties',
        instances: [],
        roles: `${userRoleConst.ADMIN}`,
        requiresAuth: true,
        id: dashboardNavbarConst.PROPERTIES,
      },
      {
        label: 'pages.globalEndToEnd.dashboardNavbar.valuations',
        key: 'valuations',
        route: '/valuations',
        instances: [],
        roles: `${userRoleConst.ADMIN}`,
        requiresAuth: true,
        id: dashboardNavbarConst.VALUATIONS,
      },
      {
        label: 'pages.globalEndToEnd.dashboardNavbar.comps',
        key: 'comps',
        route: '/researchDashboard',
        instances: [],
        roles: `${userRoleConst.ADMIN}`,
        requiresAuth: true,
        id: dashboardNavbarConst.COMPS,
        hasSeparator: true,
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.Dashboard',
        route: '/dashboard',
        instances: [],
        roles: '',
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.ProjectManagement',
        route: '/projectManagement/8c40ef43-a50b-42b8-9388-539fbffe174f',
        instances: [],
        roles: '',
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.PropertyScreen',
        route: '/projectManagement/8c40ef43-a50b-42b8-9388-539fbffe174f/141472f7-b421-4473-a23d-980269f33cc1',
        hasSeparator: true,
        instances: [],
        roles: '',
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.ClientManagement',
        route: null,
        instances: [],
        roles: `${userRoleConst.VIEW_LOAD_AREA}`,
        fn(scope) {
          scope.redirectToGea('TalosArea/ClientInfo');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.PropertyManagement',
        route: null,
        instances: [],
        roles: `${userRoleConst.VIEW_LOAD_AREA}`,
        fn(scope) {
          scope.redirectToGea('TalosArea/DBProperty');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.PersonasManagement',
        route: '/personasList',
        instances: [],
        roles: '',
        hasSeparator: true,
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.ResearchDashboard',
        route: '/researchDashboard',
        instances: [],
        roles: '',
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.ResearchView',
        route: '/research/EB8CE677-5488-4D64-8AF9-E2E75B49FBE1',
        instances: [],
        roles: '',
      },
      {
        label: 'Mandate Detail',
        route: '/mandates/12345678/edit',
        instances: [],
        roles: '',
      },
    ],
  },
  // Valuation
  {
    label: 'components.home.NavigationBarComponent.Valuation.Title',
    instances: [],
    roles: `${userRoleConst.VAS_USER}`,
    requiresAuth: true,
    children: [
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.Projects',
        route: null,
        instances: [instanceConst.US],
        roles: `${userRoleConst.VIEW_DUE_LEGAL_AREA_FILE_FILE_LIST}`,
        fn(scope) {
          scope.redirectToGea('DueLegalArea/File/FileList');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.Map',
        route: null,
        instances: [instanceConst.US],
        roles: `${userRoleConst.VIEW_MAP_DATA_AREA_MAP_DATA_MAIN_MAP}`,
        fn(scope) {
          scope.redirectToGea('MapDataArea/MapData/MainMap');
        },
        hasSeparator: true,
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.Dashboard',
        route: '/dashboard',
        instances: [instanceConst.US],
        roles: '',
        hasSeparator: true,
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.ResearchDashboard',
        route: '/researchDashboard',
        instances: [instanceConst.UK, instanceConst.CA],
        roles: `${userRoleConst.VAS_USER}`,
        hasSeparator: true,
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.ClientManagement',
        route: null,
        instances: [instanceConst.US],
        roles: `${userRoleConst.VAS_USER}`,
        fn(scope) {
          scope.redirectToGea('TalosArea/ClientInfo');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.PropertyManagement',
        route: null,
        instances: [instanceConst.US],
        roles: `${userRoleConst.VAS_USER}`,
        fn(scope) {
          scope.redirectToGea('TalosArea/DBProperty');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.PersonasManagement',
        route: '/personasList',
        instances: [instanceConst.US],
        roles: `${userRoleConst.VAS_USER}`,
        hasSeparator: true,
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.ComparableSearch',
        route: '/comparablesSearch',
        instances: [],
        roles: `${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_USERS}`,
      },
      {
        label: 'components.home.NavigationBarComponent.Valuation.Menu.Certification',
        route: '/certificationList',
        instances: [instanceConst.US],
        roles: `${userRoleConst.VAS_CERTIFICATION_SECTION_MNG}`,
      },
      {
        label: 'navbar.treppPropertyReport',
        instances: [instanceConst.US],
        roles: '',
        fn(scope) {
          scope.openTREPP();
        },
      },
    ],
  },
  // Pricing Tool
  {
    label: 'components.home.NavigationBarComponent.PricingTool.Title',
    instances: [instanceConst.US],
    roles: `${userRoleConst.VAS_USER}`,
    requiresAuth: true,
    children: [
      {
        label: 'components.home.NavigationBarComponent.PricingTool.Menu.PricingTool',
        route: '/PricingTool',
        instances: [],
        roles: '',
      },
    ],
  },
  // Terraform
  {
    label: 'Configurations',
    instances: [],
    roles: `${userRoleConst.ADMIN}`,
    requiresAuth: true,
    children: [
      {
        label: 'TerraForm',
        route: '/terraForm',
        instances: [],
        roles: `${userRoleConst.PIX_TERRAFORM_CRUD}`,
      },
      {
        label: 'TerraCards',
        route: '/terraCards',
        instances: [],
        roles: `${userRoleConst.PIX_TERRAFORM_CRUD}`,
      },
      {
        label: 'ParamList',
        route: '/paramlist',
        instances: [],
        roles: `${userRoleConst.ADMIN},${userRoleConst.RF_TALOS_PARAMLIST_MANAGEMENT}`,
      },
    ],
  },
  // TalosLib
  {
    label: 'TalosLib',
    instances: [],
    roles: '',
    requiresAuth: true,
    children: [
      {
        label: 'Loading...',
        route: null,
        instances: [],
        roles: '',
        temp: true, // when true, this route acts as a loading placeholder until replaced by the expected route
      },
    ],
  },
  // Admin
  {
    label: 'components.home.NavigationBarComponent.ADMIN.Title',
    instances: [],
    roles: `${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_USERS},${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_PROFILES},${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_ROLES},${userRoleConst.VIEW_QTAG_INDEX},${userRoleConst.VIEW_ADMIN_AREA_AUTHORIZATION_MAPPING_INDEX},${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_USER_PROFILE_ROLE},${userRoleConst.DEV_MODE}`,
    requiresAuth: true,
    children: [
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.Users',
        route: '/users',
        instances: [],
        roles: `${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_USERS}`,
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.Profiles',
        route: '/profiles',
        instances: [],
        roles: `${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_PROFILES}`,
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.Roles',
        route: '/roles',
        instances: [],
        roles: `${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_ROLES}`,
        hasSeparator: true,
      },
      {
        label: 'API HealthCheck',
        route: '/healthcheck',
        instances: [],
        roles: 'RF_PIX_MONITORING',
      },
      {
        label: 'API DataSource',
        route: '/datasource',
        instances: [],
        roles: 'RF_PIX_MONITORING',
      },
      {
        label: 'SignalR',
        route: '/signalr',
        instances: [],
        roles: 'ADMIN',
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.ViewAs',
        route: null,
        instances: [],
        roles: `${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_USER_PROFILE_ROLE}`,
        fn(scope) {
          scope.redirectToGea('AdminArea/Users/MngUserProfileRole');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.Tagging',
        route: null,
        instances: [],
        roles: `${userRoleConst.VIEW_QTAG_INDEX}`,
        fn(scope) {
          scope.redirectToGea('QTag');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.Mapping',
        route: null,
        instances: [],
        roles: `${userRoleConst.VIEW_ADMIN_AREA_AUTHORIZATION_MAPPING_INDEX}`,
        fn(scope) {
          scope.redirectToGea('AdminArea/AuthorizationMapping');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.ClearCaches.ClearCaches',
        route: '/clearCaches',
        instances: [],
        roles: `${userRoleConst.VIEW_ADMIN_AREA_USERS_MNG_USERS},${userRoleConst.ADMIN}`,
        hasSeparator: true,
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.OpenDev',
        route: null,
        instances: [],
        roles: '',
        fn(scope) {
          scope.replaceUrl('pixvuedev.qrmjll.com');
        },
      },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.OpenLocal',
        route: null,
        instances: [],
        roles: '',
        fn(scope) {
          // Localhost will always use the port 44301, as it's specified in the launchSettings.json
          scope.replaceUrl('localhost:44301');
        },
      },
    ],
  },
  // Instances
  {
    label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.Title',
    instances: [],
    roles: `${userRoleConst.RF_CHANGE_INSTANCE}`,
    requiresAuth: true,
    children: [
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.UK',
        name: `instance-${instanceConst.UK}`,
        route: null,
        instances: [],
        roles: '',
        imgSource: instanceConst.UK,
        fn(scope) {
          scope.changeInstance(instanceConst.UK);
        },
      },
       {
         label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.ES',
         name: `instance-${instanceConst.ES}`,
         route: null,
         instances: [],
         roles: '',
         imgSource: instanceConst.ES,
         fn(scope) {
           scope.changeInstance(instanceConst.ES);
         },
       },
       {
         label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.PT',
         name: `instance-${instanceConst.PT}`,
         route: null,
         instances: [],
         roles: '',
         imgSource: instanceConst.PT,
         fn(scope) {
           scope.changeInstance(instanceConst.PT);
         },
       },
       {
         label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.IT',
         name: `instance-${instanceConst.IT}`,
         route: null,
         instances: [],
         roles: '',
         imgSource: instanceConst.IT,
         fn(scope) {
           scope.changeInstance(instanceConst.IT);
         },
       },
       {
         label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.FR',
         name: `instance-${instanceConst.FR}`,
         route: null,
         instances: [],
         roles: '',
         imgSource: instanceConst.FR,
         fn(scope) {
           scope.changeInstance(instanceConst.FR);
         },
       },
       {
         label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.CH',
         name: `instance-${instanceConst.CH}`,
         route: null,
         instances: [],
         roles: '',
         imgSource: instanceConst.CH,
         fn(scope) {
           scope.changeInstance(instanceConst.CH);
         },
       },
      {
        label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.US',
        name: `instance-${instanceConst.US}`,
        route: null,
        instances: [],
        roles: '',
        imgSource: instanceConst.US,
        fn(scope) {
          scope.changeInstance(instanceConst.US);
        },
      },
       {
         label: 'components.home.NavigationBarComponent.ADMIN.Menu.DevMode.Instance.CA',
         name: `instance-${instanceConst.CA}`,
         route: null,
         instances: [],
         roles: '',
         imgSource: instanceConst.CA,
         fn(scope) {
           scope.changeInstance(instanceConst.CA);
         },
       },
    ],
  },
];
